import constants from './-constants'
import { SpaceState } from './-types'

export default {
  [constants.getter.GET_SPACE](state: SpaceState) {
    return state.space
  }
}
